import React, { useState } from "react";
import * as XLSX from "xlsx";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

const Bulkexcelattendance = () => {
  const [groupedJson, setGroupedJson] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewCount, setPreviewCount] = useState(0);

  // ---------------------- PARSE EXCEL -----------------------
  const handleFile = async (e) => {
    setError("");
    setSuccess("");
    setGroupedJson(null);
    setPreviewCount(0);

    const file = e.target.files[0];
    if (!file) return;

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });

      const result = {};
      let r = 0;

      while (r < rows.length) {
        const row = rows[r].map((c) =>
          c === null || c === undefined ? "" : String(c).trim()
        );

        const empIdx = row.findIndex(
          (cell) =>
            /^Employee\s*Code[:]?$/i.test(cell) ||
            /^Employee\s*Code/i.test(cell)
        );

        if (empIdx !== -1) {
          let empcode = "";
          for (let k = empIdx + 1; k < row.length; k++) {
            if (row[k] !== "") {
              empcode = row[k];
              break;
            }
          }

          if (!empcode) {
            let rr = r + 1;
            while (rr < rows.length && !empcode) {
              const row2 = rows[rr].map((c) =>
                c === null || c === undefined ? "" : String(c).trim()
              );
              for (let k = 0; k < row2.length; k++) {
                if (row2[k] !== "" && !/Employee\s*Name/i.test(row2[k])) {
                  empcode = row2[k];
                  break;
                }
              }
              rr++;
              if (rr - r > 4) break;
            }
          }

          empcode = empcode.toString();

          let headerRow = -1;
          let headerMap = {};

          for (let j = r + 1; j < Math.min(rows.length, r + 30); j++) {
            const rr = rows[j].map((c) =>
              c === null || c === undefined ? "" : String(c).trim()
            );
            const joined = rr.join(" ").toLowerCase();

            if (
              joined.includes("date") &&
              (joined.includes("intime") ||
                joined.includes("in time") ||
                joined.includes("in")) &&
              (joined.includes("outtime") ||
                joined.includes("out time") ||
                joined.includes("out"))
            ) {
              headerRow = j;
              for (let ci = 0; ci < rr.length; ci++) {
                const cell = rr[ci].toString().toLowerCase();
                if (cell.includes("date")) headerMap.date = ci;
                if (
                  cell.includes("intime") ||
                  cell === "in" ||
                  cell.includes("in time")
                )
                  headerMap.in = ci;
                if (
                  cell.includes("outtime") ||
                  cell === "out" ||
                  cell.includes("out time")
                )
                  headerMap.out = ci;
                if (cell.includes("status")) headerMap.status = ci;
              }
              break;
            }
          }

          if (headerRow !== -1) {
            if (!result[empcode]) result[empcode] = [];

            for (let x = headerRow + 1; x < rows.length; x++) {
              const rr = rows[x].map((c) =>
                c === null || c === undefined ? "" : String(c).trim()
              );
              const joined = rr.join(" ").toLowerCase();

              if (
                joined.includes("total duration") ||
                joined.includes("employee code") ||
                joined.startsWith("total ")
              ) {
                r = x;
                break;
              }

              const nonEmpty = rr.filter((c) => c !== "");
              if (nonEmpty.length === 0) {
                r = x;
                break;
              }

              const dateVal =
                headerMap.date !== undefined ? rr[headerMap.date] : rr[0];
              if (!dateVal || String(dateVal).toLowerCase().includes("total")) {
                continue;
              }

              const inVal = headerMap.in !== undefined ? rr[headerMap.in] : "";
              const outVal =
                headerMap.out !== undefined ? rr[headerMap.out] : "";
              const statusVal =
                headerMap.status !== undefined ? rr[headerMap.status] : "";

              result[empcode].push({
                date: dateVal,
                in_time: inVal,
                out_time: outVal,
                status: statusVal,
              });

              setPreviewCount((prev) => prev + 1);
            }
          } else {
            r++;
          }
        } else {
          r++;
        }
      }

      setGroupedJson(result);
    } catch (err) {
      console.error(err);
      setError("Failed to parse file: " + (err.message || err));
    }
  };

  // ---------------------- SEND TO API -----------------------
  const handleUpload = async () => {
    if (!groupedJson) {
      setError("Please upload and parse an Excel file first.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertEmployeeExcelAttendance`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(groupedJson),
        }
      );

      const data = await res.json();
      console.log("API Response:", data);

      if (data.status === "0") {
        setSuccess("✅ Attendance data uploaded successfully!");
      } else {
        setError("Upload failed: " + (data.msg || "Unknown error"));
      }
    } catch (err) {
      console.error(err);
      setError("API request failed: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  // ---------------------- UI -----------------------
  return (
    <div>
      <div className="card p-3 m-4">
        <h5>Upload Excel (xls / xlsx)</h5>
        <input
          className="form-control"
          type="file"
          accept=".xls,.xlsx"
          onChange={handleFile}
        />
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {groupedJson && (
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Parsed JSON (grouped)</h5>
            <div>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={handleUpload}
                disabled={loading}
              >
                {loading ? "Uploading..." : "Upload to Server"}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="list-group">
                {Object.keys(groupedJson).map((key) => (
                  <button
                    key={key}
                    className="list-group-item list-group-item-action"
                    onClick={() => {
                      const el = document.getElementById("json-preview");
                      el.textContent = JSON.stringify(
                        { [key]: groupedJson[key] },
                        null,
                        2
                      );
                    }}
                  >
                    {key} ({groupedJson[key].length})
                  </button>
                ))}
              </div>
            </div>
            <div className="col-md-8">
              <pre
                id="json-preview"
                className="json-output border rounded p-2 bg-light"
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  fontSize: "13px",
                }}
              >
                {JSON.stringify(groupedJson, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bulkexcelattendance;
